import { CAN_INSTALL, NO_MOBILE } from '../../utils/extensionSupport';

export const CLIPPER_VERSION = '3.0.1';
export const CLIPPER_ZIP = '/downloads/keymade-clipper-v3.zip';

function ago(days) {
  if (days === 0) return 'today';
  if (days === 1) return 'yesterday';
  return `${days} days ago`;
}

/**
 * DP30 — the sentence, in one place, so all three surfaces read the same, and
 * pure, so it can be tested without a browser or a network.
 *
 * It never asserts an installation state it cannot know. See ClipperState.js
 * for the full account of what is measured and what is inferred.
 */
export function clipperSentence({ marker, lastClip, support }) {
  if (support.state === NO_MOBILE) {
    return { headline: 'Web Clipper — this device cannot install extensions', share: true };
  }
  if (support.state !== CAN_INSTALL && support.state !== 'unknown') {
    return { headline: 'Web Clipper — needs desktop Chrome or Edge' };
  }
  if (marker) {
    return marker === CLIPPER_VERSION
      ? { headline: `Web Clipper — installed, v${marker}` }
      : { headline: `Web Clipper — v${marker} installed, v${CLIPPER_VERSION} available`, action: 'Update' };
  }
  if (lastClip.loading) return { headline: 'Web Clipper — checking clip activity' };
  if (lastClip.days !== null) {
    return { headline: `Web Clipper — last clip ${ago(lastClip.days)}`, action: 'Update' };
  }
  return {
    headline: 'Web Clipper — no clips from this device yet',
    action: 'Install',
    hint: 'If it is already installed, clipping something will confirm it.',
  };
}
